import type { Http } from '../http';
import { endpoints } from '../endpoints';
import type {
  RawCoordinateParams,
  RawClimate,
  RawForecastResponse,
  RawSunResponse,
} from '../types/weather';
import type { RequestOptions } from '../types/common';

export function createWeatherApi(http: Http) {
  return {
    async getClimate(
      coords: RawCoordinateParams,
      period: 'hourly' | 'daily' | 'monthly',
      start?: string,
      end?: string,
      options?: RequestOptions,
    ): Promise<RawClimate> {
      const res = await http.get<RawClimate>(endpoints.weather.climate(period, start, end), {
        params: coords,
        signal: options?.signal,
      });
      return res.data;
    },

    async getForecast(
      coords: RawCoordinateParams,
      start?: string,
      end?: string,
      options?: RequestOptions,
    ): Promise<RawForecastResponse> {
      const res = await http.get<RawForecastResponse>(endpoints.weather.forecast(start, end), {
        params: coords,
        signal: options?.signal,
      });
      return res.data;
    },

    async getSun(
      coords: RawCoordinateParams,
      start?: string,
      end?: string,
      options?: RequestOptions,
    ): Promise<RawSunResponse> {
      const res = await http.get<RawSunResponse>(endpoints.weather.sun(start, end), {
        params: coords,
        signal: options?.signal,
      });
      return res.data;
    },
  };
}
